// client/src/ui/SettingsManager.js
window.SettingsManager = {
    init: function () {
        // Modal & Button
        const btn = document.getElementById('nav-settings-btn'); // Sidebar button
        const headerBtn = document.getElementById('header-settings-btn'); // Header button
        const modal = document.getElementById('settings-modal');
        const close = document.getElementById('close-settings-btn');

        if (modal && close) {
            this.openSettings = () => {
                modal.classList.remove('hidden');
                if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

                // [A11Y] Focus Trap
                if (window.AccessibilityManager) {
                    window.AccessibilityManager.trapFocus(modal);
                }

                // [LAZY LOAD] Initialize backgrounds only when needed
                if (!this.backgroundsInitialized && this.initBackgroundSettings) {
                    this.initBackgroundSettings();
                    this.backgroundsInitialized = true;
                }

                // [FIX] Re-bind listeners in case DOM changed or just to be safe
                if (this.initInterfaceSettings) this.initInterfaceSettings();
            };

            const openSettings = this.openSettings; // Local alias for internal use

            if (btn) {
                btn.addEventListener('click', () => {
                    openSettings();
                    // [FIX] Close sidebar when opening settings from sidebar
                    const sidebar = document.getElementById('app-sidebar');
                    const sbOverlay = document.getElementById('sidebar-overlay');
                    if (sidebar) sidebar.classList.remove('active');
                    if (sbOverlay) {
                        sbOverlay.classList.remove('active');
                        setTimeout(() => sbOverlay.classList.add('hidden'), 300);
                    }
                });
            }

            if (headerBtn) {
                headerBtn.addEventListener('click', openSettings);
            }

            close.addEventListener('click', () => {
                modal.classList.add('hidden');
                if (window.AccessibilityManager) window.AccessibilityManager.releaseFocus();
            });

            // Close on outside click
            modal.addEventListener('click', (e) => {
                if (e.target === modal) {
                    modal.classList.add('hidden');
                    if (window.AccessibilityManager) window.AccessibilityManager.releaseFocus();
                }
            });

            // ESC key is now handled globally in navigation.js
        }

        // Toggles & Slider
        const sToggle = document.getElementById('sfx-toggle-check');
        const sSlider = document.getElementById('sfx-volume-slider');

        if (window.audio) {
            const updateSliderProgress = (slider) => {
                if (!slider) return;
                const val = (slider.value - slider.min) / (slider.max - slider.min) * 100;
                slider.style.setProperty('--progress', `${val}%`);
            };
            window.updateSliderProgress = updateSliderProgress; // Expose globally

            // Sync with current audio state
            if (sToggle) sToggle.checked = window.audio.sfxVolume > 0;
            if (sSlider) {
                sSlider.value = window.audio.sfxVolume;
                updateSliderProgress(sSlider);

                sSlider.addEventListener('input', (e) => {
                    const vol = parseFloat(e.target.value);
                    window.audio.setSFXVolume(vol);
                    if (sToggle) sToggle.checked = vol > 0;
                    updateSliderProgress(e.target);

                    if (window.wheel) {
                        if (window.wheel.audio) window.wheel.audio.volume = vol * 0.4;
                        if (window.wheel.audioSuccess) window.wheel.audioSuccess.volume = vol * 0.6;
                    }
                });
            }

            if (sToggle) {
                sToggle.addEventListener('change', (e) => {
                    const isChecked = e.target.checked;
                    const newVol = isChecked ? 0.6 : 0;

                    if (isChecked) {
                        window.audio.setSFXVolume(newVol);
                        window.audio.playSound('toggle_on');
                        if (window.AccessibilityManager) window.AccessibilityManager.announce("Ses efektleri açıldı");
                    } else {
                        window.audio.playSound('toggle_off');
                        if (window.AccessibilityManager) window.AccessibilityManager.announce("Ses efektleri kapatıldı");
                        window.audio.setSFXVolume(newVol);
                    }
                    if (sSlider) {
                        sSlider.value = newVol;
                        updateSliderProgress(sSlider);
                    }

                    if (window.wheel) {
                        if (window.wheel.audio) window.wheel.audio.volume = isChecked ? 0.4 : 0;
                        if (window.wheel.audioSuccess) window.wheel.audioSuccess.volume = isChecked ? 0.6 : 0;
                    }
                });
            }
        }

        // Music Selector Moved to MusicWidget


        // --- INTERFACE SETTINGS (Chat & Scoreboard Sizes) ---
        if (window.SettingsManager.initInterfaceSettings) {
            window.SettingsManager.initInterfaceSettings();
        }

        // [NEW] Accessibility Modal Logic
        const accModal = document.getElementById('accessibility-modal');
        const accOpenBtn = document.getElementById('open-accessibility-btn');
        const accCloseBtn = document.getElementById('close-accessibility-btn');

        if (accModal && accCloseBtn) {
            // Document-level listener for dynamic button (since it's in a screen that might be hidden/shown)
            // But Screen elements are static in layout, so direct listener might work if layout is rendered first.
            // Layout is rendered in Main, so element exists.

            // However, WaitingRoomScreen might be hidden initially. Button exists though.

            // Use delegation or direct if element exists
            if (accOpenBtn) {
                accOpenBtn.addEventListener('click', () => {
                    accModal.classList.remove('hidden');
                    // Ensure settings are applied/synced
                    if (this.initInterfaceSettings) this.initInterfaceSettings();
                });
            } else {
                // Fallback delegation for safety if button is dynamically re-created
                document.addEventListener('click', (e) => {
                    if (e.target && e.target.id === 'open-accessibility-btn' || e.target.closest('#open-accessibility-btn')) {
                        accModal.classList.remove('hidden');
                        if (this.initInterfaceSettings) this.initInterfaceSettings();
                    }
                });
            }

            accCloseBtn.addEventListener('click', () => accModal.classList.add('hidden'));

            // Close on outside click
            accModal.addEventListener('click', (e) => {
                if (e.target === accModal) accModal.classList.add('hidden');
            });
        }


        // --- BACKGROUND RESTORE (Immediate) ---
        // Must happen on load, not on open
        const savedBG = localStorage.getItem('gaddar_bg');
        console.log('[SettingsManager] Init - Saved BG:', savedBG);

        if (savedBG) {
            // Use requestAnimationFrame to ensure DOM paint/layout is ready
            requestAnimationFrame(() => {
                this.applyBackground(savedBG);
            });
        }

        // --- SAFE AREA RESTORE ---
        const savedSafeX = localStorage.getItem('gaddar_safe_x') || 0;
        const savedSafeY = localStorage.getItem('gaddar_safe_y') || 0;
        this.applySafeArea(savedSafeX, savedSafeY, false); // False = no calibration overlay on init

        // Init UI listeners if modal is openable
        this.initScreenSettings();

        // [NEW] Text Color Settings
        this.initTextColorSettings();
    },

    initTextColorSettings: function () {
        const container = document.getElementById('text-color-selector');
        if (container) {
            const buttons = container.querySelectorAll('.color-btn');

            // Load saved
            const savedColor = localStorage.getItem('gaddar_text_color') || '#ffffff';
            this.applyTextColor(savedColor);

            buttons.forEach(btn => {
                const color = btn.dataset.color;

                // Set Active State
                if (color === savedColor) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }

                btn.onclick = () => {
                    // Update Active UI
                    buttons.forEach(b => b.classList.remove('active'));
                    btn.classList.add('active');

                    // Apply & Save
                    this.applyTextColor(color);
                    localStorage.setItem('gaddar_text_color', color);
                };
            });
        }
    },

    applyTextColor: function (color) {
        document.documentElement.style.setProperty('--question-text-color', color);
    },

    initScreenSettings: function () {
        const xSlider = document.getElementById('safe-x-slider');
        const ySlider = document.getElementById('safe-y-slider');
        const xLabel = document.getElementById('safe-x-val');
        const yLabel = document.getElementById('safe-y-val');
        const container = document.getElementById('game-container');

        const updateSliderProgress = (slider) => {
            if (!slider) return;
            const val = (slider.value - slider.min) / (slider.max - slider.min) * 100;
            slider.style.setProperty('--progress', `${val}%`);
        };

        const updateUI = (x, y) => {
            if (xSlider) {
                xSlider.value = x;
                updateSliderProgress(xSlider);
            }
            if (ySlider) {
                ySlider.value = y;
                updateSliderProgress(ySlider);
            }
            if (xLabel) xLabel.innerText = x + '%';
            if (yLabel) yLabel.innerText = y + '%';
        };

        const savedX = localStorage.getItem('gaddar_safe_x') || 0;
        const savedY = localStorage.getItem('gaddar_safe_y') || 0;
        updateUI(savedX, savedY);

        const handleInput = (isX) => (e) => {
            const val = e.target.value;
            const currentX = xSlider ? xSlider.value : (localStorage.getItem('gaddar_safe_x') || 0);
            const currentY = ySlider ? ySlider.value : (localStorage.getItem('gaddar_safe_y') || 0);

            this.applySafeArea(currentX, currentY, true); // True = show calibration border
            updateSliderProgress(e.target);

            if (isX) {
                if (xLabel) xLabel.innerText = val + '%';
                localStorage.setItem('gaddar_safe_x', val);
            } else {
                if (yLabel) yLabel.innerText = val + '%';
                localStorage.setItem('gaddar_safe_y', val);
            }
        };

        const handleChange = () => {
            // Remove calibration border when user releases slider
            if (container) container.classList.remove('calibration-mode');
        };

        if (xSlider) {
            xSlider.addEventListener('input', handleInput(true));
            xSlider.addEventListener('change', handleChange);
        }
        if (ySlider) {
            ySlider.addEventListener('input', handleInput(false));
            ySlider.addEventListener('change', handleChange);
        }
    },

    applySafeArea: function (x, y, showCalibration = false) {
        const root = document.documentElement;
        root.style.setProperty('--safe-inset-x', x + '%');
        root.style.setProperty('--safe-inset-y', y + '%');

        const container = document.getElementById('game-container');
        if (container) {
            if (showCalibration) container.classList.add('calibration-mode');
            else container.classList.remove('calibration-mode');
        }
    },


    initInterfaceSettings: function () {
        // --- Helper to bind Custom UI Group to Select (Button Toggle) ---
        const bindModernUI = (groupSelector, selectID, storageKey, callback) => {
            const group = document.getElementById(groupSelector);
            const select = document.getElementById(selectID);

            if (group && select) {
                const buttons = group.querySelectorAll('.acc-btn');
                const savedVal = localStorage.getItem(storageKey) || select.value;
                select.value = savedVal;
                if (callback) callback.call(this, savedVal);

                buttons.forEach(btn => {
                    if (btn.dataset.val === savedVal) btn.classList.add('active');
                    else btn.classList.remove('active');
                    btn.onclick = () => {
                        buttons.forEach(b => b.classList.remove('active'));
                        btn.classList.add('active');
                        const val = btn.dataset.val;
                        select.value = val;
                        localStorage.setItem(storageKey, val);
                        if (callback) callback.call(this, val);
                    };
                });
            }
        };

        // --- Helper for Range Sliders ---
        const bindRangeUI = (rangeID, labelID, storageKey, callback) => {
            const range = document.getElementById(rangeID);
            const label = document.getElementById(labelID);

            if (range) {
                const savedVal = localStorage.getItem(storageKey) || range.value;
                range.value = savedVal;

                const update = (val) => {
                    if (label) label.innerText = val + 'pt';
                    if (callback) callback.call(this, val);
                };

                update(savedVal); // Initial

                range.addEventListener('input', (e) => {
                    const val = e.target.value;
                    localStorage.setItem(storageKey, val);
                    update(val);
                });
            }
        };

        // 1. Chat Size (Range)
        bindRangeUI('chat-size-range', 'chat-size-val', 'gaddar_chat_size', this.applyChatSize);

        // 2. Chat Position (Buttons)
        bindModernUI('chat-pos-group', 'chat-position-select', 'gaddar_chat_pos', this.applyChatPosition);

        // 3. Scoreboard Size (Range)
        bindRangeUI('score-size-range', 'score-size-val', 'gaddar_score_size', this.applyScoreSize);
    },

    applyChatPosition: function (pos) {
        if (window.ChatManager && window.ChatManager.setPosition) {
            window.ChatManager.setPosition(pos);
        }
        if (!window.state) window.state = {};
        window.state.chatPosition = pos;
    },

    applyChatSize: function (size) {
        // Slider returns number/string. Ensure it ends with 'pt'
        let sizePt = String(size);
        if (!sizePt.endsWith('pt')) sizePt += 'pt';

        if (window.ChatManager && window.ChatManager.updateFontSize) {
            window.ChatManager.updateFontSize(sizePt);
        }
        if (!window.state) window.state = {};
        window.state.chatFontSize = sizePt;
    },

    applyScoreSize: function (size) {
        let sizePt = String(size);
        if (!sizePt.endsWith('pt')) sizePt += 'pt';

        if (window.OnlineGameUI && window.OnlineGameUI.updateScoreFontSize) {
            window.OnlineGameUI.updateScoreFontSize(sizePt);
        }
        if (!window.state) window.state = {};
        window.state.scoreFontSize = sizePt;
    },

    initBackgroundSettings: function () {
        const bgContainer = document.getElementById('bg-selector-grid'); // Container olarak kullanacağız (artık grid değil wrapper olacak)
        // Eğer CSS'de id="bg-selector-grid" display: grid ise bunu JS ile değiştirmemiz veya içindeki yapıyı bozmamamız lazım.
        // En temiz yol: bgContainer'ın stilini "display: flex; flex-direction: column; gap: 15px;" yapmak.

        if (bgContainer) {
            bgContainer.style.display = 'flex';
            bgContainer.style.flexDirection = 'column';
            bgContainer.style.gap = '15px';
            bgContainer.innerHTML = '';
        } else {
            return;
        }

        const body = document.body;

        // 2. FOTOĞRAFLI ARKA PLANLAR (YENİLER)
        const photoBackgrounds = [
            { name: 'Masaüstü 1', file: '/assets/backgrounds/1.png', id: 'bg1-custom' },
            { name: 'Masaüstü 2', file: '/assets/backgrounds/2.png', id: 'bg2-custom' },
            { name: 'Masaüstü 3', file: '/assets/backgrounds/3.png', id: 'bg3-custom' },
            { name: 'Masaüstü 4', file: '/assets/backgrounds/4.png', id: 'bg4-custom' }
        ];

        // --- HELPER: KATEGORİ OLUŞTURUCU ---
        const createCategory = (title, items, appendUploadBtn = false) => {
            // Başlık
            const header = document.createElement('label');
            header.className = 'group-label';
            header.style.marginTop = '0.5rem';
            header.style.marginBottom = '0.5rem';
            header.style.display = 'block';
            header.style.fontSize = '0.8rem';
            header.style.color = '#aaa';
            header.textContent = title;
            bgContainer.appendChild(header);

            // Grid Container
            const grid = document.createElement('div');
            grid.className = 'bg-selector-grid-inner'; // Yeni class, style verelim
            grid.style.display = 'grid';
            grid.style.gridTemplateColumns = 'repeat(3, 1fr)';
            grid.style.gap = '10px';
            bgContainer.appendChild(grid);

            // Resimler
            items.forEach(bg => {
                const div = document.createElement('div');
                div.className = 'bg-option';
                div.title = bg.name;
                div.dataset.type = 'image';
                div.dataset.val = bg.file;

                // [A11Y] Klavye Erişilebilirliği
                div.setAttribute('tabindex', '0');
                div.setAttribute('role', 'button');
                div.setAttribute('aria-label', `${bg.name} Arka Planını Seç`);

                // Klavye ile Tıklama (Enter / Space)
                div.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        div.click();
                    }
                });

                const safeUrl = encodeURI(bg.file);
                div.style.backgroundImage = `url('${safeUrl}')`;
                div.style.backgroundSize = 'cover';
                div.style.backgroundPosition = 'center';

                grid.appendChild(div);
            });

            // Upload Butonu (Sadece ikinci kategoriye ekleyelim)
            if (appendUploadBtn) {
                const uploadLabel = document.createElement('label');
                uploadLabel.className = 'bg-upload-btn bg-option'; // bg-option stilini de alsın
                uploadLabel.title = 'Kendi Resmini Yükle';

                // [A11Y] Upload Button Keyboard Support
                uploadLabel.setAttribute('tabindex', '0');
                uploadLabel.setAttribute('role', 'button');
                uploadLabel.setAttribute('aria-label', 'Kendi resmini yükle');

                uploadLabel.innerHTML = `+ <input type="file" id="bg-upload-input" accept="image/*" style="display: none;">`;
                uploadLabel.style.display = 'flex';
                uploadLabel.style.alignItems = 'center';
                uploadLabel.style.justifyContent = 'center';
                uploadLabel.style.background = 'rgba(255,255,255,0.1)';
                uploadLabel.style.border = '2px dashed rgba(255,255,255,0.3)';

                // [A11Y] Klavye Desteği Logic
                uploadLabel.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        const input = document.getElementById('bg-upload-input');
                        if (input) input.click();
                    }
                });

                grid.appendChild(uploadLabel);
            }
        };

        // Kategorileri Çiz
        createCategory('ARKA PLANLAR', photoBackgrounds, true);

        // --- EVENT LISTENER & UPLOAD LOGIC ---

        // 1. Upload Event (Yeniden eklendiği için tekrar tanımlanmalı)
        // Delegate etmek yerine direkt element bulup eklemek daha güvenli çünkü ID unique.
        const newUploadInput = document.getElementById('bg-upload-input');
        if (newUploadInput) {
            newUploadInput.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (readerEvent) => {
                        const result = readerEvent.target.result;

                        // Upload edilen resmi hemen ekle (Fotoğraflı gridinin sonuna)
                        const newOption = document.createElement('div');
                        newOption.className = 'bg-option selected';
                        newOption.dataset.type = 'image';
                        newOption.dataset.val = result;
                        newOption.style.backgroundImage = `url(${result})`;
                        newOption.style.backgroundSize = 'cover';

                        // "Fotoğraflı" gridini bul (Son grid)
                        const grids = bgContainer.querySelectorAll('.bg-selector-grid-inner');
                        const lastGrid = grids[grids.length - 1];
                        const uploadBtn = lastGrid.querySelector('.bg-upload-btn');

                        lastGrid.insertBefore(newOption, uploadBtn); // Upload'dan önce ekle

                        // Diğerlerini deselect et
                        document.querySelectorAll('.bg-option').forEach(el => el.classList.remove('selected'));
                        this.applyBackground(`url(${result})`);
                        localStorage.setItem('gaddar_bg', `url(${result})`);
                    };
                    reader.readAsDataURL(file);
                }
            });
        }

        // 2. Seçenek Tıklama (Event Delegation on Container)
        bgContainer.addEventListener('click', (e) => {
            const option = e.target.closest('.bg-option');
            // Upload butonuna tıklayınca bg değişmesin, dosya seçici açılsın
            if (option && !option.classList.contains('bg-upload-btn')) {
                document.querySelectorAll('.bg-option').forEach(el => el.classList.remove('selected'));
                option.classList.add('selected');

                const val = option.dataset.val;
                const safeVal = encodeURI(val);
                const bgStr = `url('${safeVal}')`;

                this.applyBackground(bgStr);
                localStorage.setItem('gaddar_bg', bgStr);
            }
        });

        // 3. Başlangıç Seçimi
        // 3. Başlangıç Seçimi'ni Güncelle (Apply ETMEMELİ, sadece Highlight etmeli)
        const savedBG = localStorage.getItem('gaddar_bg');
        if (savedBG) {
            // Already applied in init or previous logic
            // Just highlight
            const options = document.querySelectorAll('.bg-option');
            options.forEach(opt => {
                const val = opt.dataset.val;
                if (val && savedBG.includes(encodeURI(val))) {
                    opt.classList.add('selected');
                }
            });
        } else {
            // Default select (SADECE HIGHLIGHT, apply yapma çünkü CSS default zaten var)
            const defaultOption = document.querySelector(`.bg-option[data-val$="site arka plan.png"]`);
            if (defaultOption) {
                defaultOption.classList.add('selected');
            }
        }
    },

    applyBackground: function (bgValue) {
        const bgAnimation = document.getElementById('bg-animation');
        console.log('[SettingsManager] applyBackground called with:', bgValue);
        console.log('[SettingsManager] bg-animation element found:', !!bgAnimation);

        // Eğer bg-animation div'i varsa ona uygula (Asıl arka plan burada)
        const target = bgAnimation || document.body;
        console.log('[SettingsManager] Target element:', target.tagName, target.id);

        // Eğer 'url' veya 'gradient' içeriyorsa direkt uygula
        if (bgValue.includes('url') || bgValue.includes('gradient')) {
            // Okunabilirlik için hafif bir karanlık katman ekleyelim (Overlay)
            // Ancak bgValue zaten bir gradient ise (Color seçeneği) overlay ekleme
            if (bgValue.includes('url')) {
                target.style.background = `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), ${bgValue}`;
            } else {
                target.style.background = bgValue;
            }

            target.style.backgroundSize = 'cover';
            target.style.backgroundPosition = 'center';
            target.style.backgroundRepeat = 'no-repeat';

            // Eğer body'ye uyguluyorsak fixed yap
            if (target === document.body) {
                target.style.backgroundAttachment = 'fixed';
            }
        } else {
            // Varsayılan (Remove inline style to revert to CSS)
            target.style.background = '';
        }
    }
};
